import { useState, type FormEvent } from 'react';
import { PROFILES, type Profile } from '../../shared/types';
import { createSession } from '../lib/api';

interface LoginProps {
  onAuthenticated: (profile: Profile) => void;
}

export function Login({ onAuthenticated }: LoginProps) {
  const [profile, setProfile] = useState<Profile>('Jonathan');
  const [passphrase, setPassphrase] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setSubmitting(true);
    setError('');

    try {
      await createSession(passphrase, profile);
      onAuthenticated(profile);
    } catch (submitError) {
      setError(submitError instanceof Error ? submitError.message : 'Could not sign in');
      setSubmitting(false);
    }
  };

  return (
    <main className="login">
      <div className="login__landscape" aria-hidden="true">
        <img
          className="login__image"
          src="/images/big-bear-welcome.jpg"
          alt=""
          fetchPriority="high"
        />
      </div>
      <section className="login__content" aria-labelledby="LoginTitle">
        <p className="eyebrow">July 21—24, 2026</p>
        <h1 id="LoginTitle">Big Bear</h1>
        <p className="login__intro">A private place for our trip photos and videos.</p>

        <form className="login__form" onSubmit={submit}>
          <fieldset className="profile-picker">
            <legend>Who are you?</legend>
            <div className="profile-picker__options">
              {PROFILES.map((name) => (
                <label
                  className={`profile-picker__option${
                    name === 'Mama + Papa' ? ' profile-picker__option--parents' : ''
                  }`}
                  key={name}
                >
                  <input
                    type="radio"
                    name="profile"
                    value={name}
                    checked={profile === name}
                    onChange={() => setProfile(name)}
                  />
                  <span>{name}</span>
                </label>
              ))}
            </div>
          </fieldset>

          <label className="field">
            <span>Family passphrase</span>
            <input
              type="password"
              value={passphrase}
              onChange={(event) => setPassphrase(event.target.value)}
              autoComplete="current-password"
              required
            />
          </label>

          {error && (
            <p className="form-error" role="alert">
              {error}
            </p>
          )}

          <button className="button button--primary login__submit" disabled={submitting}>
            {submitting ? 'Opening…' : 'Open gallery'}
          </button>
        </form>
      </section>
    </main>
  );
}
